import { DeleteOutlined, DollarOutlined, EditOutlined, RightOutlined, WalletOutlined } from '@ant-design/icons'
import type { Partner } from '@entities/partner/model/types'
import { Avatar, Button, Flex, Space, theme, Typography } from 'antd'
import { Dialog } from 'antd-mobile'
import { useNavigate } from 'react-router'
import * as styles from './mobile-partner.module.scss'

const { Text } = Typography

interface MobilePartnerProps {
    partner: Partner
    onDelete: () => void
}

export const MobilePartner = ({ partner, onDelete }: MobilePartnerProps) => {
    const {
        token: { colorError, colorSuccess }
    } = theme.useToken()

    const navigate = useNavigate()

    return (
        <div className={styles.container}>
            <Flex justify="space-between" align="center" style={{ marginBottom: '10px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <Avatar src={partner.photoUrl} size={40} />
                    <Text style={{ fontSize: '17px', fontWeight: 600 }}>{partner.name}</Text>
                </div>
                <div>
                    <Button
                        type="text"
                        danger
                        style={{ padding: '4px 5px' }}
                        onClick={() =>
                            Dialog.confirm({
                                content: 'Вы уверены что хотите удалить партнера?',
                                cancelText: 'Отмена',
                                confirmText: 'Удалить',
                                onConfirm: onDelete
                            })
                        }
                    >
                        <DeleteOutlined style={{ fontSize: '20px' }} />
                    </Button>
                    <Button
                        type="text"
                        style={{ padding: '4px 5px' }}
                        onClick={() => navigate(`/advertising/partners/${partner.id}`)}
                    >
                        <EditOutlined style={{ fontSize: '20px' }} />
                    </Button>
                </div>
            </Flex>
            <Flex justify="space-between" align="center">
                <Text>{partner.tgUsername}</Text>
                <Space>
                    <Space size={6}>
                        <WalletOutlined style={{ color: colorError }} />
                        <Text>{partner.statistics?.purchasedAmount || 0} Р</Text>
                    </Space>
                    <Space size={6}>
                        <DollarOutlined style={{ color: colorSuccess }} />{' '}
                        <Text>{partner.statistics?.soldAmount || 0} Р</Text>
                    </Space>
                </Space>
                <Button
                    type="text"
                    style={{ padding: '8px', borderRadius: '50%', backgroundColor: '#F0F3F5' }}
                    onClick={() => navigate(`/advertising/partners/${partner.id}`)}
                >
                    <RightOutlined />
                </Button>
            </Flex>
        </div>
    )
}
